
import { Component, ElementRef } from '@angular/core';
import { PageBase } from 't4core';
@Component({
  selector: 'PTTransactions',
  templateUrl: './PTTransactions.html',
})
export class PTTransactionsComponent extends PageBase {
    constructor(el: ElementRef) {
      super(el, "PTTransactions");
    }
}
